import { createTrackingEmitterHooks } from "@b2bportal/core-tracking";
import type { PageOpenedRawEvent } from "./PageOpened";
import type { SearchSuggestionTappedRawEvent } from "./SearchSuggestionTapped";
import { TrackingRawEventName } from "./TrackingRawEventName";
import type { ViewedWebviewRawEvent } from "./WebviewRawEvent";

export const CommonRawEventName = {
  ...TrackingRawEventName,
};

export type { PageOpenedRawEvent };

export type CommonCoreRawEvent =
  | ViewedWebviewRawEvent
  | SearchSuggestionTappedRawEvent
  | PageOpenedRawEvent;

export const {
  useEmitRawEvent: useEmitCoreCommonRawEvent,
  useEmitRawEventOnce: useEmitCoreCommonRawEventOnce,
  useEmitBeforeLoad: useEmitCoreCommonEventBeforeLoad,
} = createTrackingEmitterHooks<CommonCoreRawEvent>();
